import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

//import components
import StrucutreListItemContent from './StrucutreListItemContent.js';

class StrucutreListItemSingle extends Component {
    render() {
        const {label, shortDescription, recordsNumber, id, setStructureListHeight} = this.props;

        return (
            <li className="structure__list-item--single">
                <div className="structure__list-item--single__container">
                    <StrucutreListItemContent id={id} label={label} shortDescription={shortDescription} recordsNumber={recordsNumber}
                        setStructureListHeight={setStructureListHeight}/>
                </div>
            </li>
        );
    };
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(StrucutreListItemSingle));



// WEBPACK FOOTER //
// ./src/components/characteristics/StrucutreListItemSingle.js